export enum TrajectoryStatus {
    ToPlan = 0,
    Planned = 1,
    InTransit = 2,
    Completed = 3,
    Empty = 4,
    Received = 5,
    Outsourced = 6,
    OutsourceCancelled = 7,
    Refused = 8,
    Rejected = 9
}

export const TrajectoryStatusOptions = [
    {
        label: "core.trajectory_status.to_plan",
        value: TrajectoryStatus.ToPlan
    },
    {
        label: "core.trajectory_status.planned",
        value: TrajectoryStatus.Planned
    },
    {
        label: "core.trajectory_status.in_transit",
        value: TrajectoryStatus.InTransit
    },
    {
        label: "core.trajectory_status.completed",
        value: TrajectoryStatus.Completed
    },
    {
        label: "core.trajectory_status.empty",
        value: TrajectoryStatus.Empty
    },
    {
        label: "core.trajectory_status.received",
        value: TrajectoryStatus.Received
    },
    {
        label: "core.trajectory_status.outsourced",
        value: TrajectoryStatus.Outsourced
    },
    {
        label: "core.trajectory_status.rejected",
        value: TrajectoryStatus.Rejected
    },
]
